import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  gap: 60px;
  overflow: hidden;

  @media (max-width: 850px) {
    flex-direction: column;
    gap: 24px;
    height: auto;
    overflow: visible;
  }
`;

const Chart = styled.div`
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;

  @media (max-width: 850px) {
    min-height: 360px;
  }
`;

const Sidebar = styled.div<{ $scroll: boolean }>`
  width: 358px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-height: 0;
  overflow-y: ${({ $scroll }) => ($scroll ? 'auto' : 'visible')};

  @media (max-width: 850px) {
    width: 100%;
    overflow-y: visible;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SectionTitle = styled.div`
  color: var(--text-primary);
  font-size: 16px;
  font-family: var(--font-bold);
`;

const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background: var(--line-gray);
`;

const CompetitorsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

type Props = {
  chart: React.ReactNode;
  primaryEntry: React.ReactNode;
  competitorEntries: React.ReactNode[];
  scrollSidebar?: boolean;
};

const CommunityPositioningLayout = ({ chart, primaryEntry, competitorEntries, scrollSidebar = true }: Props) => (
  <Container>
    <Chart>{chart}</Chart>
    <Sidebar className={scrollSidebar ? 'mini-scroll' : undefined} $scroll={scrollSidebar}>
      <Section>
        <SectionTitle>My Community</SectionTitle>
        <SectionDivider />
        {primaryEntry}
      </Section>
      <Section>
        <SectionTitle>Competitors</SectionTitle>
        <SectionDivider />
        <CompetitorsList>{competitorEntries}</CompetitorsList>
      </Section>
    </Sidebar>
  </Container>
);

export default CommunityPositioningLayout;
